import moment from 'moment';

const apiFormatDate = (date) => {
  return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")
}
export default apiFormatDate



// WEBPACK FOOTER //
// ./src/services/setTheDateToTheApiFormat.js